// Consent-aware Algolia Insights helpers.
//
// The actual `aa("init", ...)` call lives in
// `src/components/client/Consent/AlgoliaInsightsBootstrap.tsx` and only
// runs after the user has accepted the configured OneTrust category
// (default C0002 Performance). This file intentionally does NOT run any
// init side-effects at module import time — that was the behavior the
// OneTrust audit flagged as dropping the `_ALGOLIA` cookie on page
// load regardless of consent.

export const getUserToken = async (
  callback?: (err: Error | null, userToken?: string) => void,
): Promise<string | undefined> => {
  const { default: aa } = await import("search-insights")
  let userToken: string | undefined

  aa("getUserToken", null, (err: any, newUserToken: any) => {
    if (callback) {
      callback(err, newUserToken)
      return
    }
    if (err) return
    userToken = newUserToken
  })

  return userToken
}
